module.exports = __webpack_public_path__ + "img/c3ced4c.jpg";